import moment from 'moment';
import {
  EMPTY_ILLUSTRATIONS,
  EmptyContainer,
  ICONS,
  Icon,
  Loader,
  ProfileView,
  Table,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';
import { useGetGanttAbsenceByDate } from 'src/hooks/gantts-records/get-gannt-absence-by-date.hook';
import InfiniteScroll from 'react-infinite-scroll-component';
import { getFormattedDateForAbsence } from 'src/common/helpers/date.helpers';
import {
  HeaderContainer,
  TableContainer,
  TableHeaderLeftContainer,
  WidgetContainer,
} from './widgets.styles';

const AbsencesWidgetContainer = ({ t }: { t: Function }) => {
  const { absences, loading, onTableChange, paginationConfig, setPage } = useGetGanttAbsenceByDate(
    moment().startOf('day').toDate(),
    moment().endOf('day').toDate()
  );

  return (
    <WidgetContainer>
      <HeaderContainer>
        <TableHeaderLeftContainer>
          <Icon icon={ICONS.absences} />
          <Typography weight="bold">{t('labels.absences')}</Typography>
        </TableHeaderLeftContainer>
      </HeaderContainer>
      <TableContainer id="absencesTableContainer">
        {absences.length > 0 ? (
          <InfiniteScroll
            dataLength={absences.length}
            next={() => setPage(prev => prev + 1)}
            hasMore={absences.length < paginationConfig.total}
            loader={<Loader />}
            scrollableTarget="absencesTableContainer"
          >
            <Table
              dataSource={absences}
              onChange={onTableChange}
              rowKey={record => record.employee.id}
              loading={loading}
            >
              <Table.Column
                title={t('table.tabs.employee')}
                dataIndex="employee"
                sorter
                render={record => (
                  <ProfileView
                    key={`profile-${record.name}`}
                    name={record.name}
                    avatar={record.avatar}
                    regularWeight
                  />
                )}
              />
              <Table.Column
                title={t('table.tabs.date')}
                dataIndex="date"
                sorter
                render={record => (
                  <Typography>
                    {getFormattedDateForAbsence(
                      record.startDate.replace(/-/g, '.'),
                      record.endDate.replace(/-/g, '.')
                    )}
                  </Typography>
                )}
              />
              <Table.Column
                title={t('table.tabs.reason')}
                dataIndex="reason"
                render={reason => <Typography>{reason}</Typography>}
              />
            </Table>
          </InfiniteScroll>
        ) : (
          <EmptyContainer illustration={EMPTY_ILLUSTRATIONS.board} emptyTitle={t('table.empty')} />
        )}
      </TableContainer>
    </WidgetContainer>
  );
};

export default AbsencesWidgetContainer;
